import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=538b4d82&"
import script from "./NextSteps.vue?vue&type=script&lang=ts&"
export * from "./NextSteps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538b4d82')) {
      api.createRecord('538b4d82', component.options)
    } else {
      api.reload('538b4d82', component.options)
    }
    module.hot.accept("./NextSteps.vue?vue&type=template&id=538b4d82&", function () {
      api.rerender('538b4d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/NextSteps.vue"
export default component.exports